import React, { useEffect, useRef } from "react";
import { useStyles } from "./style";

const formatTime = (date) => {
  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";
  return `${hours}:${minutes} ${ampm}`;
};

function getScrollableParent(element) {
  let parent = element?.parentElement;
  while (parent) {
    const style = getComputedStyle(parent);
    const overflowY = style.overflowY;
    const isScrollable =
      (overflowY === "auto" || overflowY === "scroll") &&
      parent.scrollHeight > parent.clientHeight;

    if (isScrollable) return parent;
    parent = parent.parentElement;
  }
  return null;
}

const isSlotInTimeRange = (date, selectedTimeRange) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  switch (selectedTimeRange) {
    case 0:
      return hours >= 8 && hours < 12;
    case 1:
      return hours >= 12 && hours < 16;
    case 2:
      if (hours >= 16 && hours <= 20) {
        if (hours === 20 && minutes === 30) return false;
        return true;
      } else return false;
    default:
      return true;
  }
};

const getSlotClassName = (index, type, classes, selectedSlot) => {
  const baseClasses = [classes.slotButton];

  switch (type) {
    case 1:
      baseClasses.push(classes.occupied);
      break;
    case 2:
      baseClasses.push(classes.available);
      if (selectedSlot.slotButtonState === index) {
        baseClasses.push(classes.availableSelected);
      }
      break;
    case 3:
      baseClasses.push(classes.onRequest);
      if (selectedSlot.slotButtonState === index) {
        baseClasses.push(classes.onRequestSelected);
      }
      break;
    default:
      baseClasses.push(classes.occupied);
  }

  return baseClasses.join(" ");
};

export const SlotBtns = ({
  displayedSlots,
  selectedSlot,
  onSlotClick,
  selectedTimeRange,
}) => {
  const classes = useStyles();

  const sortedSlots = React.useMemo(() => {
    return [...displayedSlots]
      .filter((slot) =>
        isSlotInTimeRange(new Date(slot.slotDateTz), selectedTimeRange)
      )
      .sort((a, b) => a.slotDate.localeCompare(b.slotDate));
  }, [displayedSlots, selectedTimeRange]);

  const handleSlotClick = (slot, index) => {
    if (slot.type !== 1) {
      onSlotClick(slot, index);
    }
  };

  const ref = useRef(null);

  useEffect(() => {
    if (selectedSlot.type === 3 && ref.current) {
      const scrollableParent = getScrollableParent(ref.current);
      if (scrollableParent) {
        scrollableParent.scrollTo({
          top: scrollableParent.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  }, [selectedSlot.type]);

  return (
    <>
      <div className={classes.slotInfo}>
        <p>
          <span style={{ background: "#31AF6D" }} /> Available
        </p>
        <p>
          <span style={{ background: "#D8C8C0" }} /> Occupied
        </p>
        <p>
          <span style={{ background: "#F5A300" }} /> On Request
        </p>
      </div>
      {sortedSlots.length !== 0 && (
        <div className={`${classes.displaySlots} `}>
          {sortedSlots.map((slot, index) => (
            <button
              key={`slot-${slot.slotId}-${index}`}
              type="button"
              className={getSlotClassName(
                index,
                slot.type,
                classes,
                selectedSlot
              )}
              disabled={slot.type === 1}
              onClick={() => handleSlotClick(slot, index)}
            >
              {formatTime(new Date(slot.slotDateTz))}
            </button>
          ))}
        </div>
      )}
      {sortedSlots.length === 0 && (
        <div style={{ height: "43px" }}>No slots available</div>
      )}
      {selectedSlot.type === 3 && (
        <div ref={ref} className={classes.noticeText}>
          On request slots require teacher approval which may take up to 4
          hours. You can track status on Codeyoung App.
        </div>
      )}
    </>
  );
};
